const actions = {
    async handleMakeCohost({dispatch}, data) {
      let res = await dispatch('api/nav/makeCoHost', data)
      dispatch('analytics/promoteGuestToRoomCoHost', data)

      if(res.success) {
        dispatch('popups/show/success/custom', 'User promoted to co-host')
      } else {
        dispatch('popups/show/error/custom', 'promoting this user to co-host')
      }
      return res
    },
    async handleMadeCohost({dispatch, rootGetters}, data) {
      let myUserId = rootGetters['current_user/id']
      let myRoomId = rootGetters['getCurrentUsersRoomId']

      if (data.userId !== myUserId || data.spaceId !== myRoomId) return // this dont concern me

      dispatch('permissions/setPermissions', data.permissions, {root: true})
      dispatch('popups/show/success',{
        message: 'You are now a co-host of this Room.'
      }, {root: true})
    }
  };

  export default {
    actions
  };
